
import { Component, Prop, Vue } from "vue-property-decorator";
import QaVue from "../qa/Qa.vue";
import { RouterHelper } from "@/router/routerHelper";
import { HttpHelper } from "@/helper/httpHelper";
import { AxiosResponse } from "axios";

@Component({
  components: {
    qa: QaVue,
  },
})
export default class LiteBeeBrix3QaVue extends Vue {
  prodName: string = "LiteBee Brix III";
  prodCode: string = "liteBeeBrix3";

  tabList: Array<any> = [];
  linkData: Array<any> = [
    { name: "首页", link: "/" },
    { name: this.prodName, link: "/product/liteBeeBrix3" },
    { name: "常见问题", link: "#" },
  ];

  mounted() {
    RouterHelper.getProdRouterConfig(this.prodCode, (data: Array<any>) => {
      this.tabList = data;
    });
  }
}
